// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as AllocationDashboardAssetsManager from "../../../../assets/AllocationDashboardAssetsManager.bs.js";

var editIcon = AllocationDashboardAssetsManager.getImage("edit-icon.svg");

var deleteIcon = AllocationDashboardAssetsManager.getImage("delete-icon.svg");

var closeIcon = AllocationDashboardAssetsManager.getImage("close-icon.svg");

function SidebarHeaderCmp(Props) {
  var preview = Props.preview;
  var campaign_name = Props.campaign_name;
  var discard_warning_required = Props.discard_warning_required;
  var dispatch = Props.dispatch;
  if (preview) {
    return React.createElement("div", {
                className: "campaign-details-header"
              }, React.createElement("p", {
                    className: "campaign-name"
                  }, Belt_Option.getWithDefault(campaign_name, "Create Campaign")), React.createElement("div", {
                    className: "view-campaign-actions"
                  }), React.createElement("div", {
                    className: "view-campaign-actions"
                  }, React.createElement("span", {
                        onClick: (function (_event) {
                            if (discard_warning_required) {
                              return Curry._1(dispatch, {
                                          TAG: /* OpenModal */10,
                                          modal: {
                                            isOpen: true,
                                            onCancel: (function (param) {
                                                return Curry._1(dispatch, /* CloseModal */3);
                                              }),
                                            onSubmit: (function (param) {
                                                Curry._1(dispatch, /* CloseModal */3);
                                                return Curry._1(dispatch, {
                                                            TAG: /* UpdateSidebarState */6,
                                                            opened_sidebar: undefined
                                                          });
                                              }),
                                            title: "Discard Changes",
                                            confirm_button_title: "Yes, Discard",
                                            cancel_button_title: "No, Cancel",
                                            modal_body: "You are about to leave this page. All the changes will be lost. Are you sure you wish to exit?"
                                          }
                                        });
                            } else {
                              return Curry._1(dispatch, {
                                          TAG: /* UpdateSidebarState */6,
                                          opened_sidebar: undefined
                                        });
                            }
                          })
                      }, React.createElement("img", {
                            className: "action",
                            src: closeIcon
                          }))));
  } else {
    return React.createElement("div", {
                className: "campaign-details-header"
              }, React.createElement("p", {
                    className: "campaign-name"
                  }, Belt_Option.getWithDefault(campaign_name, "Create Campaign")), React.createElement("div", {
                    className: "view-campaign-actions"
                  }, React.createElement("span", {
                        onClick: (function (_event) {
                            return Curry._1(dispatch, {
                                        TAG: /* UpdateSidebarState */6,
                                        opened_sidebar: undefined
                                      });
                          })
                      }, React.createElement("img", {
                            className: "action",
                            src: closeIcon
                          }))));
  }
}

var make = SidebarHeaderCmp;

export {
  editIcon ,
  deleteIcon ,
  closeIcon ,
  make ,
  
}
/* editIcon Not a pure module */
